import './Members';
import './WelfareOfficer';
import './OnCourtTeam';
import './FreeParkTennisAdministrator';
import EventHandler from '../../../utils/dom/event-handler';
import SelectorEngine from '../../../utils/dom/selector-engine';
import {
	EDIT_CARD_INFO_REMOVE_ERROR_EVENT,
	EDIT_CARD_INFO_REMOVE_START_EVENT
} from '../../../webComponents/EditCardInfo';

const WRAPPER_SELECTOR = '.p-team-information';
const ERROR_SNACKBAR_SELECTOR = 'lta-error-snackbar.js-remove-contact-error';

const getRemoveErrorSnackbar = (wrapper) => SelectorEngine.findOne(ERROR_SNACKBAR_SELECTOR, wrapper);

const hideRemoveContactError = (wrapper) => {
	getRemoveErrorSnackbar(wrapper)?.hide?.();
};

const showRemoveContactError = (wrapper, errorMessage) => {
	const snackbar = getRemoveErrorSnackbar(wrapper);
	if (!errorMessage || !snackbar?.show) {
		return;
	}

	snackbar.show(errorMessage);
	snackbar.scrollIntoView({
		behavior: 'smooth',
		block: 'center'
	});
};

const initRemoveContactError = () => {
	const wrapper = SelectorEngine.findOne(WRAPPER_SELECTOR);
	if (!wrapper) {
		return;
	}

	EventHandler.on(wrapper, EDIT_CARD_INFO_REMOVE_START_EVENT, () => {
		hideRemoveContactError(wrapper);
	});

	EventHandler.on(wrapper, EDIT_CARD_INFO_REMOVE_ERROR_EVENT, (event) => {
		showRemoveContactError(wrapper, event.detail?.errorMessage);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initRemoveContactError);
} else {
	initRemoveContactError();
}
